import { useProtectionPlanBigTicketDescription } from '@composables/useProtectionPlanBigTicketDescription';
import { useFeatureEligibility } from '@modules/featureControl';
import { fireLinkTag } from '../features/analytics/tagManager';

export function useProtectionPlanBigTicket() {
  const { isProtectionPlanEligible } = useFeatureEligibility();
  const { planDescription, allPlans } = useProtectionPlanBigTicketDescription();
  const { planTerm } = planDescription; // default value for planDescription will be an empty object
  /**
   * @param {Boolean} isChecked
   */
  const fireLinkTagOnPlanSelection = (isChecked) => {
    let deselect = '';
    if (!isChecked) {
      deselect = '_deselect';
    }
    if (planTerm) {
      const event = {
        link_name: `worry_no_more_checkbox_${(planTerm.split('-'))[0]}_year${deselect}`,
      };
      fireLinkTag(event);
    }
  };

  return {
    isProtectionPlanEligible,
    planDescription,
    allPlans,
    fireLinkTagOnPlanSelection,
  };
}

export default useProtectionPlanBigTicket;
